import React from 'react';
import { ProductBoxStatic, useProductBox } from '@fourthwall/module-product';
export const HomeProductsProductBox = ({ product, href }) => {
    const productBox = useProductBox({ product });
    return (React.createElement(ProductBoxStatic, { size: "compact", product: product, href: href, activeProduct: productBox.activeProduct }));
};
